import { render } from "./DesktopHome.vue?vue&type=template&id=69095ee7&scoped=true"
import script from "./DesktopHome.vue?vue&type=script&lang=js"
export * from "./DesktopHome.vue?vue&type=script&lang=js"

import "../../assets/css/desktop.css?vue&type=style&index=0&id=69095ee7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-69095ee7"

export default script